import { getSundays } from '~/lib/utils/datetime_utility';
import CommonMixin from '../../mixins/common_mixin';
import { PRESET_TYPES } from '../../constants';
export default {
    name: 'MonthsHeaderSubItem',
    mixins: [
        CommonMixin
    ],
    props: {
        currentDate: {
            type: Date,
            required: true
        },
        timeframeItem: {
            type: Date,
            required: true
        }
    },
    data () {
        return {
            // eslint-disable-next-line vue/no-unused-properties -- `presetType` used by the `CommonMixin` mixin
            presetType: PRESET_TYPES.MONTHS,
            indicatorStyle: {}
        };
    },
    computed: {
        headerSubItems () {
            return getSundays(this.timeframeItem);
        },
        headerSubItemClass () {
            const currentYear = this.currentDate.getFullYear();
            const currentMonth = this.currentDate.getMonth();
            const timeframeYear = this.timeframeItem.getFullYear();
            const timeframeMonth = this.timeframeItem.getMonth();
            // Show dark color text only for dates from current month and future months.
            return timeframeYear >= currentYear && timeframeMonth >= currentMonth ? 'label-dark' : '';
        }
    },
    mounted () {
        this.$nextTick(()=>{
            this.indicatorStyle = this.getIndicatorStyles();
        });
    },
    methods: {
        getSubItemValueClass (subItem) {
            const daysToClosestWeek = this.currentDate.getDate() - subItem.getDate();
            // Show dark color text only for upcoming dates
            // and current week date
            if (daysToClosestWeek <= 6 && this.currentDate.getDate() >= subItem.getDate() && this.currentDate.getFullYear() === subItem.getFullYear() && this.currentDate.getMonth() === subItem.getMonth()) {
                return 'label-dark label-bold';
            }
            if (subItem >= this.currentDate) {
                return 'label-dark';
            }
            return '';
        }
    }
};
